import { postUserRegister } from "../../api/v1/user/register/post"
import { UserRegisterPostInputModel } from "../../api/v1/user/register/PostInputModel"

export const registerUser = () => {
  return postUserRegister(new UserRegisterPostInputModel())
}
